import React from "react";
import "../assets/styles/LandingPage.css"; 
import HeroSection from '../components/HeroSection';
import { useNavigate } from "react-router-dom";
import { FaBolt, FaGlobe, FaUsers, FaClock, FaWhatsapp, FaPhone } from "react-icons/fa";
import PricingSection from "../components/PricingSection";
import BotaoContato from "../components/common/BotaoContato";

export default function LandingPage() {
  const navigate = useNavigate();

  return (
    <>
      {/* Hero Section */}
      <HeroSection />

      {/* Sobre Nós */}
      <section className="sobre-nos">
        <div className="container">
          <h2>Quem Somos</h2>
          <p>
            Desenvolvemos soluções inovadoras com inteligência artificial para aumentar a eficiência,
            reduzir custos e melhorar a experiência de clientes e equipes.
          </p>
          <p>
            Acreditamos que a IA é um recurso estratégico para qualquer negócio e estamos comprometidos
            em torná-la acessível e prática para empresas de todos os tamanhos e setores.
          </p>
        </div>
      </section>

      {/* Como Funciona */}
      <section className="como-funciona">
        <div className="container">
          <h2>Como Funciona</h2>
          <ol>
            <li><strong>Integre em minutos com seu número atual</strong> — Continue no WhatsApp web e no celular sem perder nenhuma funcionalidade.</li>
            <li><strong>IA assistida</strong> — A inteligência artificial pede auxílio somente quando não souber responder.</li>
            <li><strong>Atendimento sob comando</strong> — Configure para que a IA inicie a conversa apenas quando você decidir.</li>
            <li><strong>Configure fluxos inteligentes</strong> — Defina respostas automáticas, triagem e encaminhamento para atendentes humanos.</li>
            <li><strong>Atenda em qualquer idioma</strong> — Tradução automática e instantânea para conversas multilíngues.</li>
            <li><strong>Escale sem contratar mais</strong> — Atenda centenas ou milhares de clientes com a mesma equipe.</li>
          </ol>
        </div>
      </section>

      {/* O Problema */}
      <section className="problema">
        <div className="container">
          <h2>O Desafio</h2>
          <p>
            Empresas de todos os segmentos enfrentam o mesmo problema: poucos atendentes para muitos clientes.
            No WhatsApp, redes sociais e outros canais, filas de espera se formam, clientes desistem e oportunidades se perdem.
          </p>
        </div>
      </section>

      {/* Primeira Solução */}
      <section className="primeira-solucao">
        <div className="container">
          <div className="solucao-content">
            <div className="solucao-texto">
              <h2>Atendimento escalável, multilíngue e integrado</h2>
              <p>
                Nosso primeiro produto conecta-se ao seu atendimento no WhatsApp para automatizar respostas,
                priorizar demandas e eliminar filas de espera. Ele entende e responde em qualquer idioma, identifica quando é hora
                de acionar um atendente humano e garante que nenhum cliente fique sem retorno.
              </p>
              <ul className="beneficios">
                <li><FaBolt /> Integração rápida e simples</li>
                <li><FaGlobe /> Tradução automática em tempo real</li>
                <li><FaUsers /> Escalabilidade sem aumentar a equipe</li>
                <li><FaClock /> Redução drástica no tempo de resposta</li>
              </ul>
              <BotaoContato className="btn-primary" text="Quero conhecer" />
            </div>
            {/* <div className="solucao-imagem">
               <img src="/images/mockup-app.png" alt="Mockup do aplicativo" /> 
            </div> */}
          </div>
        </div>
      </section>

      {/* O que vem por aí */}
      <section className="futuro">
        <div className="container">
          <h2>O que vem por aí</h2>
          <p>
            Este é apenas o primeiro passo. Estamos desenvolvendo novas soluções com IA para automação de processos,
            análise inteligente de dados e integração multicanal. Nosso compromisso é criar um ecossistema de ferramentas
            que ajudem empresas a crescer de forma sustentável e inteligente.
          </p>
        </div>
      </section>

      {/* FAQ */}
      <section className="faq">
        <div className="container">
          <h2>Perguntas Frequentes</h2>
          <div className="faq-item">
            <h3><FaWhatsapp /> Funciona só no WhatsApp?</h3>
            <p>Não. Também integramos com Instagram, Facebook Messenger e chat no site.</p>
          </div>
          <div className="faq-item">
            <h3><FaBolt /> Preciso saber programar para usar?</h3>
            <p>Não. A configuração é simples e guiada.</p>
          </div>
          <div className="faq-item">
            <h3><FaGlobe /> E se meu cliente falar outro idioma?</h3>
            <p>O app traduz automaticamente a conversa em tempo real.</p>
          </div>
        </div>
      </section>

      {/* <PricingSection /> */}

      {/* CTA Final */}
      <section className="cta-final">
        <div className="container">
          <h2>Comece agora e acompanhe nossa evolução</h2>
          <p>
            Use nossa solução para transformar seu atendimento hoje.
          </p>
          <BotaoContato className="btn-primary" text="Quero começar agora" />
        </div>
      </section>
    </>
  );
}
